import { Box, Container, Heading, Alert, AlertIcon, Center, Spinner } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useItensPedido } from './hooks/useItensPedido'
import { SearchForm } from './components/SearchForm'
import { PedidoInfo } from './components/PedidoInfo'
import { CollapseTable } from './components/CollapseTable'

export function ItensPedido() {
  const { numNota, setNumNota, pedidoData, isLoading, isError, error, isFetching, isSearching, handleSearch, getStatusColor, formatDate } =
    useItensPedido()

  return (
    <Box bgColor="#313E44" minH="100vh">
      <HeadingPages name={'ITENS DO PEDIDO'} bgColor={'#5ac8fa'} />

      <Container maxW="container.xl" py={6}>
        <SearchForm numNota={numNota} setNumNota={setNumNota} isLoading={isSearching || isFetching} handleSearch={handleSearch} />

        {isError && (
          <Alert status="error" mb={6} borderRadius="md">
            <AlertIcon />
            {error?.response?.data?.message || 'Erro ao buscar os dados do pedido'}
          </Alert>
        )}

        {(isLoading || isFetching) && (
          <Center h="200px">
            <Spinner size="xl" color="#37F091" />
          </Center>
        )}

        {pedidoData && !isLoading && !isFetching && (
          <Box>
            <PedidoInfo pedidoData={pedidoData} formatDate={formatDate} />

            <Heading size="md" mb={4} color="#fff">
              Itens do Pedido
            </Heading>

            <CollapseTable items={pedidoData.itens} getStatusColor={getStatusColor} />
          </Box>
        )}
      </Container>
    </Box>
  )
}
